module.exports = __webpack_public_path__ + "public/images/rating-leader-off.a4f62f735de3e5814454f5f19954dae5.svg";